<template>
  <div>
    <div class="position-relative mb-3">
      <section class="section-profile-cover section-shaped my-0">
        <div
          class="shape shape-style-1 bg-gradient-navyDark shape-skew alpha-4"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>
    </div>
    <section class="section-skew">
      <div class="container-section">
        <card shadow class="section-home">
          <div class="row row-grid align-items-center">
            <div
              class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 text-right"
            >
              <div class="section-title">
                <h3>با طراحی سایت حرفه‌ای کسب و کار خود را رشد دهید!</h3>
                <p>
                  سفارش طراحی سایت و توسعه انواع پلتفرم متناسب با نیاز شما
                </p>
                <base-button
                  type="navyDark"
                  round
                  block
                  size="md"
                  @click="handleContactus"
                >
                  ارتباط با ما
                </base-button>
                <base-button
                  type="yellowdark"
                  round
                  block
                  size="md"
                  @click="handleProduct"
                >
                  مشاهده محصولات
                </base-button>
              </div>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
              <div class="img-main-page">
                <img src="img/home/source-bro.svg" alt="" />
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>

    <section>
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <img
              src="img/home/iteration-pana.svg"
              class="img-fluid floating-lg"
            />
          </div>
          <div class="col-md-6">
            <div class="pr-md-5 section-organizer">
              <h3>شرکت خدمات تجارت سرمد</h3>
              <p>
                شرکت خدمات تجارت سرمد، در پی دستیابی به هدف ارائه‌ی بهترین
                راهکارهای سازمانی برای مدیریت پروژه، ارتباط با مشتریان،
                سیستم‌های اتوماسیون و آموزشی، مدیریت منابع انسانی و چابکسازی
                فرآیندها می‌باشد. چشم انداز سرمد تبدیل شدن به کارآمدترین و
                مشتری‌ مدارترین شرکت در راه اندازی و بهبود سیستم‌ها و خدمات
                فناوری اطلاعات است. سرمد این فرصت را در اختیار شما می‌گذارد تا
                به صورت پیوسته، هزینه‌‍‌های سازمان خود را کاهش دهید و آن‌ها را
                تبدیل به فرصت‌هایی برای رشد سازمان و درآمدزایی بیشتر نمایید.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-xl-8 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
            <div class="section-users">
              <h3>چرا سرمد؟</h3>
              <p>
                خدمات تجارت سرمد یک گروه نرم افزاری و طراحی سایت می باشد که با
                استفاده از جدیدترین تکنولوژی‌های وب و متخصصان حرفه‌ای در زمینه‌ی
                طراحی و توسعه‌ی وب و اپلیکیشن، بهترین خدمات را به مشتریان خود
                ارائه میدهد. تیم سرمد آماده ارائه طرح‌های اختصاصی، با ظاهری
                کاملا منحصر به فرد و مطابق با ایده‌ی مشتری می باشد.
              </p>
            </div>
            <ul class="list-unstyled mt-4">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge
                    type="yellowdark"
                    circle
                    class="ml-3"
                    icon="fa fa-bar-chart"
                  ></badge>
                  <h6 class="mb-0">
                    کیفیت
                  </h6>
                </div>
                <p class="pt-2">
                  ما متعهد به ارائه راه حل های برجسته و پیشرفته فناوری اطلاعات
                  هستیم که معتقد هستیم می توانیم برای شرکت و موسسه شما ارزش
                  آفرینی بکنیم.
                </p>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge
                    type="yellowdark"
                    circle
                    class="ml-3"
                    icon="fa fa-comment-o"
                  ></badge>
                  <h6 class="mb-0">
                    پشتیبانی
                  </h6>
                </div>
                <p class="pt-2">
                  مهندسان ما قابل اعتماد، متعهد و با تجربه هستند و برای حل مسائل
                  مربوط به فناوری اطلاعات بسیار حرفه‌ای و در عین حال دوستانه
                  هستند.
                </p>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge
                    type="yellowdark"
                    circle
                    class="ml-3"
                    icon="ni ni-satisfied"
                  ></badge>
                  <h6 class="mb-0">
                    خدمات مشتری
                  </h6>
                </div>
                <p class="pt-2">
                  کارشناسان ما با دقت و دلسوزی، به نیازهای مشتریان گوش می‌دهند،
                  راه‌حل‌های موثر ارائه می‌کنند و پیگیری‌های لازم را انجام
                  می‌دهند تا تجربه‌ای مثبت و ماندگار برای مشتریان رغم بخورد.
                </p>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge
                    type="yellowdark"
                    circle
                    class="ml-3"
                    icon="fa fa-users"
                  ></badge>
                  <h6 class="mb-0">
                    تیم حرفه‌ای و با تجربه
                  </h6>
                </div>
                <p class="pt-2">
                  ما درک می‌کنیم که توانایی‌های تیم ما بر موفقیت کسب و کار ما و
                  میزان رضایت‌مندی مشتریان‌مان تأثیر می‌گذارد و ما افرادی که
                  برای سرمد ارزش آفرین باشند استخدام می کنیم.
                </p>
              </li>
            </ul>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="'img/service/Programming-pana.svg'"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <div class="title-section-first">
                  <h3>
                    همکاری با سرمد برای شما چه مزایایی به همراه دارد؟
                  </h3>
                  <p>
                    با انتخاب سرمد، شما از تخصص و تجربه یک تیم حرفه‌ای در حوزه
                    نرم‌افزار و طراحی سایت بهره‌مند می‌شوید. ما به شما
                    راه‌حل‌های خلاقانه و سفارشی ارائه می‌دهیم که به رشد و توسعه
                    کسب‌وکار شما کمک می‌کند.
                  </p>
                  <p>تجربه‌ای بی‌نظیر از کیفیت و نوآوری را با ما تجربه کنید!</p>
                </div>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-help-buy">
      <div class="container-section">
        <h3>
          اگر می‌خواهید بیشتر با خدمات ما آشنا شوید به صفحه پروژه‌های ما مراجعه
          نمایید.
        </h3>
        <h3>
          کارهایی که تا کنون انجام داده‌ایم، ادعای ما را تضمین می‌کنند.
        </h3>
      </div>
      <div>
        <b-row>
          <b-col cols="12" xl="4" lg="4" md="12" sm="12" xs="12">
            <div class="item-card-service">
              <div class="items-card">
                <img
                  src="img/service/center-cuate.svg"
                  alt=""
                  class="floating-md"
                />
              </div>
              <h4>مشتری مداری</h4>
            </div>
          </b-col>
          <b-col cols="12" xl="4" lg="4" md="12" sm="12" xs="12">
            <div class="item-card-service">
              <div class="items-card">
                <img
                  src="img/service/office-amico.svg"
                  alt=""
                  class="floating-md"
                />
              </div>
              <h4>محیط کاری بی‌نظیر</h4>
            </div>
          </b-col>
          <b-col cols="12" xl="4" lg="4" md="12" sm="12" xs="12">
            <div class="item-card-service">
              <div class="items-card">
                <img
                  src="img/service/members-rafiki.svg"
                  alt=""
                  class="floating-md"
                />
              </div>
              <h4>تیم متبحر و درجه یک</h4>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-navyDark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container-section py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/home/Open-1.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex title-section-first">
              <h1>
                سرمد: پیشرو در طراحی و توسعه انواع وبسایت و نرم‌افزار برای
                کسب‌وکارهای مدرن
              </h1>
            </div>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pr-4 title-section-first">
                  <h6>
                    خدمات تجارت سرمد، یک مجموعه‌ی پیشرو در حوزه‌ی طراحی و توسعه
                    تخصصی انواع وبسایت و نرم‌افزارهای تحت وب است که با تمرکز بر
                    تولید محصولات نوآورانه، نیازهای متنوع سازمان‌ها و کسب‌وکارها
                    را برآورده می‌کند. این شرکت با بهره‌گیری از تیمی متشکل از
                    متخصصان جوان، باانگیزه و خلاق، به ارائه‌ی راهکارهای دیجیتال
                    در راستای ارتقاء گستره‌ای از کسب‌وکارهای داخلی و بین‌المللی
                    می‌پردازد.
                  </h6>

                  <span>
                    مجموعه سرمد، با رویکردی مشتری‌محور و متمرکز بر کیفیت، به
                    دنبال ایجاد تحولی مثبت در فرآیندهای کاری مشتریان خود است.
                    این مجموعه با نگاه به آینده و درک عمیق از نیازهای روزافزون
                    دنیای دیجیتال، همواره در تلاش است تا با استفاده از
                    تکنولوژی‌های نوین و روش‌های پیشرفته در توسعه نرم‌افزار،
                    محصولات و خدمات خود را به سطح بالاتری از کیفیت و کارایی
                    برساند. این شرکت با تکیه بر دانش و تجربه تیم جوان و پویا،
                    توانسته است در مدت زمان کوتاهی، جایگاه ویژه‌ای در بازار
                    فناوری اطلاعات و توسعه نرم‌افزار به دست آورد.
                  </span>
                  <span
                    >مجموعه سرمد با بهره‌گیری از جدیدترین استانداردهای طراحی و
                    توسعه، اطمینان حاصل می‌کند که کاربران وبسایت‌ها و
                    نرم‌افزارها، تجربه‌ای ساده، روان و لذت‌بخش داشته باشند. این
                    تمرکز بر رضایت کاربران، نه تنها به افزایش بهره‌وری و کارایی
                    کاربران کمک می‌کند، بلکه باعث می‌شود تا مشتریان شرکت نیز از
                    کیفیت خدمات و محصولات ارائه‌شده راضی باشند. تعهد به پشتیبانی
                    فنی و ارائه‌ی خدمات پس از فروش، یکی دیگر از جنبه‌های با
                    اهمیت فعالیت‌های تیم سرمد است. این شرکت با ایجاد یک شبکه‌ی
                    پشتیبانی قوی، تضمین می‌کند که مشتریانش در هر زمان و مکانی که
                    نیاز به راهنمایی یا حل مشکلات داشته باشند، به سرعت و به صورت
                    مؤثر کمک‌های لازم را دریافت کنند.
                  </span>
                  <span>
                    به‌طور کلی، سرمد با رویکردی نوآورانه و آینده‌نگر، در تلاش
                    است تا با ارائه‌ی راهکارهای جامع و مدرن، به رشد و توسعه‌ی
                    کسب‌وکارها کمک کند و در مسیر دیجیتال‌سازی فرآیندهای کاری،
                    نقش مؤثری ایفا نماید. این شرکت با اهداف بزرگ و چشم‌اندازی
                    روشن، به سوی موفقیت‌های بیشتری در دنیای فناوری اطلاعات گام
                    برمی‌دارد.
                  </span>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container-section">
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="section-Popular-tours"
        >
          <h3>مشتریان سرمد</h3>
        </b-col>
        <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <hooper
            :settings="hooperSettings"
            :autoPlay="true"
            :playSpeed="2000"
            style="height:300px"
          >
            <slide
              v-for="(item, index) in listSlider"
              :key="index"
              class="slider-customer"
            >
              <div class="image-slider">
                <img :src="item.src" alt="" />
              </div>
              <div class="items-slider">
                <h6>{{ item.name }}</h6>
              </div>
            </slide>
          </hooper>
        </b-col>
      </div>
    </section>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import "hooper/dist/hooper.css";
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
export default {
  name: "home",
  components: {
    Hooper,
    Slide,
    HooperProgress,
    HooperPagination,
    HooperNavigation,
  },
  data() {
    return {
      showScrollButton: false,
      listSlider: [
        {
          src: "img/customer/پولاد.jpg",
          name: "شرکت پولاد پیچ کار",
        },
        {
          src: "img/customer/انجمن مهندسی پزشکی.jpg",
          name: "انجمن مهندسی پزشکی ایران",
        },
        {
          src: "img/customer/ستاد زیست فناوری.jpg",
          name: "ستاد توسعه زیست فناوری معاونت علمی فناوری ریاست جمهوری",
        },
        {
          src: "img/customer/لیا.jpg",
          name: "مرکز زیبایی لیا",
        },
        {
          src: "img/customer/کلینیک پارسیان البرز.jpg",
          name: "درمانگاه پارسیان البرز",
        },
        {
          src: "img/customer/خانه کسب و کار.jpg",
          name: "خانه کسب و کار (کیارش عباس زاده)",
        },
        {
          src: "img/customer/ماجرا.jpg",
          name: "مجموعه خدمات گردشگری ماجراهای شیرین",
        },
        {
          src: "img/customer/پت کلاب آس.jpg",
          name: "پت کلاب آس",
        },
        {
          src: "img/customer/کوثر.jpg",
          name: "انتشارات بین المللی کوثر",
        },
        {
          src: "img/customer/سیویلکا.jpg",
          name: "انتشارات سیویلیکا",
        },
        {
          src: "img/customer/فاطمی.jpg",
          name: "انتشارات فاطمی",
        },
        {
          src: "img/customer/سگال.jpg",
          name: "انتشارات سگال",
        },
        {
          src: "img/customer/وزارت بهداشت.jpg",
          name: "وزارت بهداشت ساحل عاج",
        },
        {
          src: "img/customer/حساب رایان.jpg",
          name: "شرکت نرم‌افزاری حساب رایان پارس",
        },
        {
          src: "img/customer/هلال احمر.jpg",
          name: "سازمان جوانان جمعیت هلال احمر",
        },
        {
          src: "img/customer/یسنا.jpeg",
          name: "موسسه سلامت‌رسان امید یسنا",
        },
        {
          src: "img/customer/نت حامی.jpg",
          name: "سازمان مردم نهاد حامیان اشتغال و کارآفرینی نت",
        },
        {
          src: "img/customer/ذهن برتر.jpg",
          name:
            "موسسه فرهنگی آموزشی ذهن برتر – دکتر محمد سیدا – پدر حافظه ایران",
        },
      ],
      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        autoPlay: true,
        playSpeed: 2000,
        breakpoints: {
          2400: {
            itemsToShow: 6,
          },
          1800: {
            itemsToShow: 5,
          },
          1100: {
            itemsToShow: 4,
          },
          900: {
            itemsToShow: 3,
          },
          600: {
            itemsToShow: 2,
          },
          400: {
            itemsToShow: 1,
          },
        },
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
    handleContactus() {
      this.$router.push("/contact-us");
    },
    handleProduct() {
      this.$router.push("/products");
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss"></style>
